import script from "./AmazonCopyResult.vue?vue&type=script&setup=true&lang=js"
export * from "./AmazonCopyResult.vue?vue&type=script&setup=true&lang=js"

import "./AmazonCopyResult.vue?vue&type=style&index=0&id=4f31a9c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f31a9c1"]])

export default __exports__